import React, {forwardRef, PropsWithChildren, useMemo} from 'react';
import Toolbar, {Item, ToolbarRef} from "devextreme-react/toolbar";
import dxButton from "devextreme/ui/button";
import IDataSource from "../../models/IDataSource";

interface IItemOptions {
    visible?: boolean,
    disabled?: boolean,
    click?: (e: any) => void,
}

export interface IFromToolbarProps {
    headerText?: string,
    ajouterOptions?: IItemOptions,
    modifierOptions?: IItemOptions,
    annulerOptions?: IItemOptions,
    effacerOptions?: IItemOptions,
    sauvegarderOptions?: IItemOptions,
    dataController?: IDataSource<any, any>
}

const GestionPaiementToolbar = forwardRef<ToolbarRef, PropsWithChildren & IFromToolbarProps>(
    ({
         ajouterOptions,
         modifierOptions,
         annulerOptions,
         effacerOptions,
         sauvegarderOptions,
         dataController
     }, ref): any => {
        //console.warn('ddd', sauvegarderOptions)
        const ajouterButtonOtions = useMemo(() => ({
            icon: 'plus',
            text: "Ajouter",
            onClick: ajouterOptions?.click,
        }), [ajouterOptions?.click])

        const modifierButtonOtions = useMemo(() => ({
            icon: 'edit', text: "Modifier", onClick: modifierOptions?.click
        }), [modifierOptions?.click])

        const effacerButtonOtions = useMemo(() => ({
            icon: 'remove',
            text: "Effacer",
            onClick: effacerOptions?.click,
        }), [effacerOptions?.click])

        const annulerButtonOtions = useMemo(() => ({
            icon: 'revert', text: "Annuler",
            onClick: annulerOptions?.click || dataController?.dataSource?.store().byKey(dataController?.selectedId),
        }), [annulerOptions?.click, dataController])

        const sauvegarderButtonOtions = useMemo(() => ({
            icon: 'save',
            text: "Sauvegarder",
            onClick: sauvegarderOptions?.click,
        }), [sauvegarderOptions?.click])

        return (
            <>
                <Toolbar className="toolbar" ref={ref}>
                    {ajouterOptions?.visible !== false ? <Item disabled={ajouterOptions?.disabled} key={"def-toolbar-item-ajouter"} location={"before"} widget={"dxButton"} locateInMenu={"auto"} options={ajouterButtonOtions}/> : null}
                    {modifierOptions?.visible !== false ? <Item disabled={modifierOptions?.disabled} key={"def-toolbar-item-modifier"} location={"before"} widget={"dxButton"} locateInMenu={"auto"} options={modifierButtonOtions}/> : null}
                    {effacerOptions?.visible !== false ? <Item disabled={effacerOptions?.disabled} key={"def-toolbar-item-effacer"} location={"before"} widget={"dxButton"} locateInMenu={"auto"} options={effacerButtonOtions}/> : null}
                    {sauvegarderOptions?.visible !== false ? <Item disabled={sauvegarderOptions?.disabled} key={"def-toolbar-item-sauvegarder"} location={"before"} widget={"dxButton"} options={sauvegarderButtonOtions}/> : null}
                    {annulerOptions?.visible !== false ? <Item disabled={annulerOptions?.disabled} key={"def-toolbar-item-annuler"} location={"before"} widget={"dxButton"} options={annulerButtonOtions}/> : null}
                </Toolbar>
            </>
        );
    });

export default GestionPaiementToolbar;